module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vue-star-rating', {
      'vue-star-rating-rtl': _vm.rtl
    }, {
      'vue-star-rating-inline': _vm.inline
    }]
  }, [_c('div', {
    staticClass: "vue-star-rating",
    on: {
      "mouseleave": _vm.resetRating
    }
  }, [_vm._l((_vm.maxRating), function(n) {
    return _c('span', {
      key: n,
      class: [{
        'vue-star-rating-pointer': !_vm.readOnly
      }, 'vue-star-rating-star'],
      style: ({
        'margin-right': _vm.margin + 'px'
      })
    }, [_c('star', {
      attrs: {
        "fill": _vm.fillLevel[n - 1],
        "size": _vm.starSize,
        "points": _vm.starPoints,
        "star-id": n,
        "step": _vm.step,
        "active-color": _vm.activeColor,
        "inactive-color": _vm.inactiveColor,
        "border-color": _vm.borderColor,
        "border-width": _vm.borderWidth,
        "rounded-corners": _vm.roundedCorners,
        "rtl": _vm.rtl,
        "glow": _vm.glow,
        "glow-color": _vm.glowColor
      },
      on: {
        "star-selected": function($event) {
          _vm.setRating($event, true)
        },
        "star-mouse-move": _vm.setRating
      }
    })], 1)
  }), _vm._v(" "), (_vm.showRating) ? _c('span', {
    class: ['vue-star-rating-rating-text', _vm.textClass]
  }, [_vm._v(" " + _vm._s(_vm.formattedRating))]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34cbeed1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/star-rating.vue
// module id = 11
// module chunks = 0